var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareableLinksApiService } from '../../sharing/links/shareable-links-api.service';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { PreviewFilesService } from 'common/file-preview/preview-files.service';
import { Settings } from 'common/core/config/settings.service';
import { CurrentUser } from 'common/auth/current-user';
import { filter, map } from 'rxjs/operators';
import { Toast } from 'common/core/ui/toast.service';
import { Store } from '@ngxs/store';
import { DownloadFile } from '../../state/actions/commands';
import { SecurityHandler } from 'app/drive/security/security-handler';
var LinkPreviewContainerComponent = /** @class */ (function () {
    function LinkPreviewContainerComponent(store, route, links, previewFiles, settings, currentUser, router, toast, el) {
        this.store = store;
        this.route = route;
        this.links = links;
        this.previewFiles = previewFiles;
        this.settings = settings;
        this.currentUser = currentUser;
        this.router = router;
        this.toast = toast;
        this.el = el;
        this.data$ = new BehaviorSubject(null);
        this.passwordPanelVisible$ = new BehaviorSubject(false);
    }
    Object.defineProperty(LinkPreviewContainerComponent.prototype, "entryAlreadyImported$", {
        /**
         * Check if current user owns this entry or
         * already has it imported into their drive.
         */
        get: function () {
            var userId = this.currentUser.get('id');
            return this.data$.pipe(map(function (data) { return data.link; }), filter(function (link) { return !!link && !!link.entry && !!link.entry.users; }), map(function (link) { return link.entry; }), map(function (entry) { return !!entry.users.find(function (user) { return user.id === userId; }); }));
        },
        enumerable: true,
        configurable: true
    });
    LinkPreviewContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bindToDownload();
        this.disableContextMenu();
        this.route.params.subscribe(function (params) {
            var hash = params.hash.split('!')[0];
            var key = params.hash.split('!')[1].replace('#', ''); // edge adds an additional # to the url
            _this.links.findByHash(hash, { withEntries: true }).subscribe(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var entry, securityHandler, _a, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 4, , 5]);
                            entry = response.link.entry;
                            if (!(!key || key == '')) return [3 /*break*/, 2];
                            return [4 /*yield*/, new SecurityHandler().decryptKeyString(entry.key)];
                        case 1:
                            key = _b.sent();
                            _b.label = 2;
                        case 2:
                            securityHandler = new SecurityHandler();
                            _a = entry;
                            return [4 /*yield*/, securityHandler.decryptString(entry.name, key)];
                        case 3:
                            _a.name = _b.sent();
                            entry.keyDec = key;
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _b.sent();
                            return [3 /*break*/, 5];
                        case 5:
                            this.data$.next(response);
                            this.setBackgroundClass(response.link);
                            if (response.link.password) {
                                this.togglePasswordPanel(true);
                            }
                            else {
                                this.togglePasswordPanel(false);
                                this.showPreview();
                            }
                            return [2 /*return*/];
                    }
                });
            }); }, function () {
                _this.router.navigate(['/404']);
            });
        });
    };
    LinkPreviewContainerComponent.prototype.ngOnDestroy = function () {
        this.downloadSub.unsubscribe();
    };
    LinkPreviewContainerComponent.prototype.import = function () {
        var _this = this;
        this.links.importEntry(this.data$.value.link.id, this.password)
            .subscribe(function (response) {
            var link = _this.data$.value.link;
            link.entry.users = response.users;
            _this.data$.next(__assign({}, _this.data$.value, { link: link }));
            _this.toast.open({
                message: "\":name\" imported into your drive.",
                replacements: { name: link.entry.name },
            });
        });
    };
    LinkPreviewContainerComponent.prototype.togglePasswordPanel = function (value) {
        this.passwordPanelVisible$.next(value);
    };
    LinkPreviewContainerComponent.prototype.bindToDownload = function () {
        var _this = this;
        this.downloadSub = this.previewFiles.download.subscribe(function () {
            var link = _this.data$.value.link;
            _this.store.dispatch(new DownloadFile(link.entry, link, _this.password));
        });
    };
    /**
     * Show preview for shareable link files.
     */
    LinkPreviewContainerComponent.prototype.showPreview = function () {
        var data = this.data$.value;
        data.link.entry.url += "?shareable_link=" + data.link.id;
        if (this.password) {
            data.link.entry.url += "&password=" + this.password;
        }
        this.data$.next(__assign({}, data));
    };
    LinkPreviewContainerComponent.prototype.setValidPassword = function (password) {
        this.password = password;
        this.showPreview();
        this.togglePasswordPanel(false);
    };
    LinkPreviewContainerComponent.prototype.setBackgroundClass = function (link) {
        var className = link.entry.type === 'folder' ? 'folder-link' : 'file-link';
        this.el.nativeElement.classList.add(className);
    };
    LinkPreviewContainerComponent.prototype.disableContextMenu = function () {
        fromEvent(this.el.nativeElement, 'contextmenu')
            .subscribe(function (e) {
            e.preventDefault();
        });
    };
    return LinkPreviewContainerComponent;
}());
export { LinkPreviewContainerComponent };
